<template>
  <div class="table-pagination">
    <div @click="onClickPrev">⇠</div>
    <div
        v-for="n in totalPages"
        :class="{'active': n === currentPage}"
        :key="n"
        @click="onClickNPage(n)"
    >{{ n }}</div>
    <div @click="onClickNext">⇢</div>
  </div>
</template>

<script>
export default {
  name: 'TablePagination',
  props: {
    limit: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    totalRecords: {
      type: Number,
      required: true,
    }
  },
  data: () => ({
    totalPages: 1,
  }),

  watch: {
    currentPage (val) {
      console.log(val)
    }
  },

  mounted() {
    this.totalPages = Math.ceil(this.totalRecords / this.limit);
  },

  methods: {
    onClickPrev () {
      if(this.currentPage > 1) {
        this.$emit('onClickPrev')
      }
    },

    onClickNext () {
      if(this.currentPage < this.totalPages) {
        this.$emit('onClickNext')
      }
    },

    onClickNPage (n) {
      if(n !== this.currentPage) {
        this.$emit('onClickNumberPage', n)
      }
    }
  }
}
</script>

<style scoped>
.table-pagination {
  display: flex;
  flex-direction: row;
  gap: 15px;
  justify-content: center;
}
.table-pagination div {
  border: 1px solid #cde0c2;
  padding: 5px;
  cursor: pointer;
  min-width: 30px;
  height: 30px;
  text-align: center;
  line-height: 18px;
  user-select: none;
  border-radius: 4px;
}

.active {
  background-color: #cde0c2;
}

</style>